import React from 'react';

import {
  SpinNumberInput,
  BaseNumberInput,
  MoneyInput,
  MaxAmountInput,
} from '@t7x000/apex-web/lib/components/form/NumberInput/index.js';
import { FormInputItem, FormItem } from '@t7x000/apex-web/lib/components/form/FormItem';
import { Input, InputWithPrefix } from '@t7x000/apex-web/lib/components/form/Input';
import { Button } from '@t7x000/apex-web/lib/components/form/Button/Button';
import { ButtonToggle } from '@t7x000/apex-web/lib/components/form/Button/ButtonToggle';
import APIcon from '@t7x000/apex-web/lib/components/common/APIcon';

import PageHeaderLayout from '../layouts/PageHeaderLayout/PageHeaderLayout';
import './demo.css';
import { BuyFormContainer } from './BuyForm';

const BUTTON_SIZES = ['xs', 'sm', 'md', 'lg'];
const BUTTON_VARIANTS = [
  'primary',
  'secondary',
  'secondary-color',
  'tertiary',
  'tertiary-color',
  'link',
  'link-color',
  'danger',
  'success',
];

const ButtonsDemo = () => {
  const [toggleStates, setToggle] = React.useReducer((state, [name, value]) => {
    return { ...state, [name]: value };
  }, {});

  return (
    <>
      {BUTTON_VARIANTS.map((variant) => (
        <>
          <h5>{variant}</h5>
          <div className="components-row">
            {BUTTON_SIZES.map((size) => (
              <Button key={`${variant}-${size}`} variant={variant} size={size}>
                Button {size}
              </Button>
            ))}
            {BUTTON_SIZES.map((size) => (
              <Button key={`${variant}-${size}-icon`} variant={variant} size={size} iconOnly>
                <APIcon name="transfer" />
              </Button>
            ))}
          </div>
          <div className="components-row">
            {BUTTON_SIZES.map((size) => (
              <Button key={`${variant}-${size}`} variant={variant} size={size} disabled>
                Button {size}
              </Button>
            ))}
          </div>
          <div className="components-row"></div>
        </>
      ))}
      <h5>Button Toggle</h5>
      <div className="components-row">
        {BUTTON_SIZES.map((size) => (
          <ButtonToggle
            key={`toggle-${size}`}
            name="size"
            variant="secondary"
            size={size}
            value={!!toggleStates[size]}
            onChange={(value) => setToggle([size, value])}>
            Toggle {size}
          </ButtonToggle>
        ))}
        <ButtonToggle
          key={`toggle-disabled`}
          name="size"
          variant="secondary"
          size="md"
          disabled
          value={!!toggleStates.disabled}
          onChange={(value) => setToggle(['disabled', value])}>
          Toggle Disabled
        </ButtonToggle>
      </div>
    </>
  );
};

const InputComponents = () => (
  <div className="components-grid">
    <FormInputItem label="Amount">
      <Input type="text" name="amount" placeholder="Enter amount" />
    </FormInputItem>
    <FormInputItem label="Disabled">
      <Input type="text" name="disabled" placeholder="Disabled" disabled />
    </FormInputItem>
    <FormInputItem label="Size" error="Error message">
      <Input type="text" name="size" placeholder="0" />
    </FormInputItem>
    <FormInputItem label="Amount">
      <InputWithPrefix prefixLabel="BTC" type="text" name="size" placeholder="0" />
    </FormInputItem>
    <FormItem>
      <label>
        <input type="checkbox" name="checkbox" id="checkbox" />
        This FormItem should not render input box border
      </label>
    </FormItem>
    <FormInputItem label="Amount">
      <MoneyInput symbol="USDT" value={0.00000001} decimalPlaces={8} onChange={console.log} />
    </FormInputItem>
    <FormInputItem label="Amount">
      <BaseNumberInput value={1234567.1234123} decimalPlaces={2} onChange={console.log} />
    </FormInputItem>
    <FormInputItem label="Amount">
      <BaseNumberInput value={543_123_432.9876} decimalPlaces={8} onChange={console.log} />
    </FormInputItem>
    <FormInputItem label="Amount">
      <BaseNumberInput value={'.0001'} decimalPlaces={8} onChange={console.log} />
    </FormInputItem>
    <FormInputItem label="Amount">
      <SpinNumberInput onChange={console.log} min={0} max={100} step={0.00000001} decimalPlaces={8} valueAs="string" />
    </FormInputItem>
    <FormInputItem label="Number with MAX" size="small">
      <MaxAmountInput onChange={console.log} maxValue={123567.8901} decimalPlaces={8} valueAs="string" />
    </FormInputItem>
  </div>
);

const InputSizes = () => (
  <div className="form-fields">
    <FormInputItem label="Small Size" size="small">
      <MoneyInput symbol="BTC" name="amount" placeholder="0" onChange={console.log} />
    </FormInputItem>
    <FormInputItem label="Default Size">
      <MoneyInput symbol="USD" name="quantity" placeholder="0" onChange={console.log} />
    </FormInputItem>
    <FormInputItem label="Large Size" size="large">
      <MoneyInput symbol="USDT" name="total" placeholder="0" onChange={console.log} />
    </FormInputItem>
  </div>
);

export const ComponentsPage = () => {
  return (
    <>
      <header className="header">
        <PageHeaderLayout />
      </header>
      <div className="demo-page">
        <h1>Components</h1>
        <h2>Buttons</h2>
        <ButtonsDemo />
        <h2>Inputs</h2>
        <InputComponents />
        <h2>Input sizes</h2>
        <InputSizes />
        <h2>Buy Form</h2>
        <BuyFormContainer />
      </div>
    </>
  );
};
